import { render, staticRenderFns } from "./WorkspaceLink.vue?vue&type=template&id=2c2d27fe&scoped=true"
import script from "./WorkspaceLink.vue?vue&type=script&lang=js"
export * from "./WorkspaceLink.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLink.vue?vue&type=style&index=0&id=2c2d27fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d27fe",
  null
  
)

export default component.exports